// extracted by mini-css-extract-plugin
export default {"title-section":"TanSLo2re8","titleSection":"TanSLo2re8","tabs":"Ody5I7dvsB"};